module.exports = __webpack_public_path__ + "images/emoji/clock430.3c83175c708811ded9ad.png";